import { createSelector } from '@reduxjs/toolkit';
import { MEETING_UUID_DELIMITER } from '../../constants/google-meet';
const googleRoot = state => state.google;
export const clientSelector = createSelector(googleRoot, ({
  client
}) => client);
export const meetingIdSelector = createSelector(googleRoot, ({
  meetingId
}) => meetingId ? meetingId.split('/').pop() : '');
export const meetSdkParamSelector = createSelector(googleRoot, ({
  meet_sdk
}) => meet_sdk);
export const originParamSelector = createSelector(googleRoot, ({
  origin
}) => origin);
export const googleConferenceRecordIdSelector = createSelector(googleRoot, ({
  conferenceRecordId
}) => conferenceRecordId ? conferenceRecordId.split('/').pop() : '');
export const meetingUUIDSelector = createSelector([meetingIdSelector, googleConferenceRecordIdSelector], (meetingId, conferenceRecordId) => {
  if (conferenceRecordId && meetingId) {
    return `${meetingId}${MEETING_UUID_DELIMITER}${conferenceRecordId}`;
  }
  return conferenceRecordId;
});
export const canViewParticipantsSelector = createSelector(googleRoot, ({
  canViewParticipants
}) => canViewParticipants);
export const meetingStartTimeSelector = createSelector(googleRoot, ({
  meetingStartTime
}) => meetingStartTime);
export const meetingUriSelector = createSelector(googleRoot, ({
  meetingUri
}) => meetingUri);